import { takeEvery } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { fetchApi } from '../utils/api';

import {
    getSchoolSuccess,
    getSchoolFailure,

    getSingleSchoolSuccess,
    getSingleSchoolFailure
} from './schoolActions';

const {
    GET_SCHOOL_REQUEST,
    GET_SINGLE_SCHOOL_REQUEST
} = require('./schoolActions').constants;

function* fetchSchool(action) {
    try {
        const response = yield call(fetchApi, {
            method: 'get',
            url: 'schools',
            params: action.payload
        });

        yield put(getSchoolSuccess(response));
    } catch (e) {
        yield put(getSchoolFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

function* fetchSingleSchool(actions) {
    try {
        const response = yield call(fetchApi, {
            method: 'get',
            url: `schools/${actions.payload.id}`
        });

        yield put(getSingleSchoolSuccess(response));
    } catch (e) {
        yield put(getSingleSchoolFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

/**
 * Watch actions
 */
export default function* schoolSaga() {
    yield* [
        takeEvery(GET_SCHOOL_REQUEST, fetchSchool),
        takeEvery(GET_SINGLE_SCHOOL_REQUEST, fetchSingleSchool),
    ];
}



/** WEBPACK FOOTER **
 ** ./src/core/school/schoolSaga.js
 **/